export const INPUTS = {
  MOBILE_NUMBER: 'mobileNumber',
  CREDIT_CARD_NUMBER: 'creditCardNumber',
  SECURITY_CODE: 'securityCode',
  ACCOUNT_NUMBER: 'accountNumber',
  LAST_FOUR_SSN: 'lastFourSSN',
  ZIP_CODE: 'zipCode'
}
